export default __webpack_public_path__ + "static/media/copy_notification_menu.bd0e2c18.svg";